import React from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
import { rolesColumnDefs, defaultColDef } from '../_utils/definitions-config';
import { IconButton } from '@material-ui/core';

import EditIcon from '@material-ui/icons/Edit';

function RolesTable({ rowData, editHandler }) {
  const ButtonRenderer = (params) => {
    return (
      <div className='flex items-center justify-left'>
        <IconButton onClick={() => editHandler(params.data)}>
          <EditIcon />
        </IconButton>
      </div>
    );
  };

  const frameworkComponents = {
    btnCellRenderer: ButtonRenderer,
  };

  return (
    <div className='ag-theme-alpine' style={{ height: '85vh', width: '100%' }}>
      <AgGridReact
        columnDefs={rolesColumnDefs}
        defaultColDef={defaultColDef}
        rowData={rowData || []}
        tooltipShowDelay={0}
        tooltipHideDelay={2000}
        pagination={true}
        paginationPageSize={10}
        paginationAutoPageSize={true}
        onGridReady={(params) => {
          params.api.sizeColumnsToFit();
        }}
        onGridSizeChanged={(params) => {
          params.api.sizeColumnsToFit();
        }}
        rowHeight={50}
        frameworkComponents={frameworkComponents}
      />
    </div>
  );
}

export default RolesTable;
